import { v4 } from 'uuid'

const CustomListLayout = ({ layout, value }) => {
  const icon = require('../../../assets/images/award.svg').default

  return (
    <div
      style={{
        padding: '16px 20px 16px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#f000f0',
      }}
    >
      <div
        style={{
          marginTop: '10px',
          marginBottom: '24px',
          textAlign: 'left',
          color: 'var(--gray100)',
          listStyle: 'none',
        }}
      >
        <p className="headline1">{layout.display_name}</p>
      </div>
      {value.map((item) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              color: 'var(--gray100)',
              margin: '16px 0px',
            }}
            key={v4()}
          >
            <img src={icon} alt="" style={{ marginRight: '14px' }}></img>
            <p
              className="body2"
              style={{ margin: '0px 0px', lineHeight: '150%' }}
            >
              {item}
            </p>
          </div>
        )
      })}
    </div>
  )
}

export default CustomListLayout
